import { connect } from 'react-redux';
import StudentXlsxUploadForm from './StudentXlsxUploadForm';

const mapStateToProps = ({ ActivityForm }) => ActivityForm;

export default connect(mapStateToProps)(StudentXlsxUploadForm);
